import { Routes } from '@angular/router';
import { MODAL_ROUTES } from '@woolworthsnz/shop';
import { HomePage } from './pages/home/home.page';

export const routes: Routes = [
	{
		path: '',
		component: HomePage,
		children: [
			{
				path: MODAL_ROUTES.FORCED_PICKUP_ON_HOMEPAGE_PATH,
				outlet: MODAL_ROUTES.HOME_MODAL,
				loadComponent: () =>
					import('./components/switched-to-pickup-modal/switched-to-pickup-modal.component').then(
						(c) => c.SwitchedToPickupModalComponent
					),
			},
			{
				path: MODAL_ROUTES.PURCHASE_BY_QUANTITY_MODAL_PATH,
				outlet: MODAL_ROUTES.HOME_MODAL,
				loadComponent: () =>
					import('./components/shop-by-quantity-modal/shop-by-quantity-modal.component').then(
						(c) => c.ShopByQuantityModalComponent
					),
			},
			{
				path: MODAL_ROUTES.CHANGE_ORDER_ONBOARDING_MODAL_PATH,
				outlet: MODAL_ROUTES.HOME_MODAL,
				loadComponent: () =>
					import('./components/change-order-onboarding-modal/change-order-onboarding-modal.component').then(
						(c) => c.ChangeOrderOnboardingModalComponent
					),
			},
		],
		data: { gtmListName: 'Home' },
	},
];
